import { render } from "./singupComponent.vue?vue&type=template&id=18616c5e"
import script from "./singupComponent.vue?vue&type=script&lang=js"
export * from "./singupComponent.vue?vue&type=script&lang=js"

import "./singupComponent.vue?vue&type=style&index=0&id=18616c5e&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/r2-disponibilidade-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__